import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westWarwickConfig } from "./data";

export default function WestWarwickPage() {
  return <CityPageTemplate config={westWarwickConfig} />;
}